import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

import TableWidget from "../../../../components/tables/TableWidget";

import { fetchUsers } from "../../../../redux/api/admin.api";
import { postCollectionErrorsDetailed } from "../../../../redux/api/reports.api";
import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import CollectionErrorsDropdwonsHeader from "../CollectionErrrorsSimplified/components/CollectionErrorsDropdwonsHeader";
import {
  collectionErrorsDetailedTableHeader,
  getCollectionErrorsDetailedTableData,
} from "./tableConfigs/collectionErrorsDetailedTableConfig";

function CollectionErrorsDetailed() {
  const dispatch = useAppDispatch();

  const {
    reports: {
      collectionErrorsDetailed: {
        data: { data: collectionErrorsDetailed, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  useEffect(() => {
    dispatch(
      fetchUsers({
        page: 1,
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      if (
        action.tableSearch.selectedMonth &&
        action.tableSearch.selectedYear &&
        action.tableSearch.selectedUsers
      ) {
        dispatch(
          postCollectionErrorsDetailed({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            selectedUsers: JSON.parse(action.tableSearch.selectedUsers),
            month: action.tableSearch.selectedMonth,
            year: action.tableSearch.selectedYear,
            day: parseInt(action.tableSearch.selectedDay),
          }),
        );
      }
    }
  };

  return (
    <TableWidget
      tableTitle="Raport detaliat"
      tableHeaderData={collectionErrorsDetailedTableHeader}
      tableItemsData={getCollectionErrorsDetailedTableData(
        collectionErrorsDetailed,
      )}
      handleTableActions={handleTableActions}
      CustomHeaderComponent={CollectionErrorsDropdwonsHeader}
      totalItems={total}
      tableLoading={isLoading}
      withGlobalSearch={false}
      withGlobalFilter={false}
    />
  );
}

export default CollectionErrorsDetailed;
